import { FC } from 'react';
import { Link } from 'react-router-dom';
import { ServiceProviderDetailsDto } from 'src/generated/services/TFinancialApi';
import { useTourContext } from 'src/presentations/guided-tours';

// Modality icon and title helpers
import { getRateCardModalityIcon, getRateCardModalityTitle } from './rateCardModalityUtils';
import { RateCardProviderList } from './RateCardProviderList';
import { GenericAccordion } from './GenericAccordion';

interface RateCardProvidersProps {
  rateCards: ServiceProviderDetailsDto[];
  modality: string;
}

export const RateCardProviders: FC<RateCardProvidersProps> = ({ rateCards, modality }) => {
  const { appTour, refreshTourSteps } = useTourContext();
  const landingTour = appTour.registerTour('rate-card-landing');
  const icon = getRateCardModalityIcon(modality);
  const title = getRateCardModalityTitle(modality);

  // Create the "See All" link for the header right content
  const headerRightContent = (
    <Link to={`/ratecard-manager?modality=${modality}`} className='text-12 xl:text-14 font-medium text-primary hover:underline'>
      See All {title} Rate Cards
    </Link>
  );

  // When accordion opens, refresh tour steps so the auto-start effect
  // detects the now-visible provider cards and starts provider-selection tour
  const handleAccordionChange = (isExpanded: boolean) => {
    if (isExpanded) {
      setTimeout(() => {
        refreshTourSteps();
      }, 400);
    }
  };

  return (
    <GenericAccordion
      id={landingTour.registerStep('accordionHeader', [], rateCards.length > 0)}
      icon={icon}
      title={title}
      providerCount={rateCards?.length || 0}
      headerRightContent={headerRightContent}
      onAccordionChange={handleAccordionChange}
    >
      {rateCards?.length > 0 ? <RateCardProviderList rateCards={rateCards} /> : <p className='text-center text-sm'>Not found</p>}
    </GenericAccordion>
  );
};
